import posthog from "posthog-js";

const rawPosthogKey = import.meta.env.VITE_POSTHOG_KEY || "phc_placeholder";
const POSTHOG_KEY = rawPosthogKey.startsWith("hc_")
  ? "p" + rawPosthogKey
  : rawPosthogKey;

if (POSTHOG_KEY && POSTHOG_KEY !== "phc_placeholder" && !posthog.__loaded) {
  posthog.init(POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
    person_profiles: "identified_only",
    loaded: (ph) => {
      // Auto-identify fallback user in development environment
      if (import.meta.env.DEV) {
        ph.identify("dev-local-user");
      }
    }
  });
}

export default posthog;
